export enum MapService {
    YANDEX = "yandex",
    DGIS = "2gis",
    GOOGLE = "google",
    YANDEX_NAVIGATOR = "yandex-navigator",
}
